import type { Schema } from '@cli-types/core-engine/schema.js'
import type {
  DevModeLifecycleHookEvent,
  DevModeLifecycleHookExample
} from '@cli-types/next-adapter/generators.js'
import { ENTITY_ACTION_FIELD_EXCLUSIONS } from '@cli-constants/generators.js'
import { singularizeLabel } from '@cli-utils/text.js'
import { getEntityFieldContext } from '@next-adapter/generators/entity-filters/get-entity-field-context.js'
import { createEntityDataObject } from './create-entity-data-object.js'
import { createInputObject } from './create-input-object.js'
import { isActionField } from './is-action-field.js'
import { lifecycleHookCode } from './lifecycle-hook-code.js'
import { lifecycleHookContextExample } from './lifecycle-hook-context-example.js'
import { lifecycleHookIcon } from './lifecycle-hook-icon.js'
import { lifecycleHookId } from './lifecycle-hook-id.js'
import { lifecycleHookPhase } from './lifecycle-hook-phase.js'
export function buildEntityDevModeLifecycleHooks(
  schema: Schema,
  adminImportAlias?: string
): DevModeLifecycleHookExample[] {
  const entityLabel = singularizeLabel(schema.label)
  const { regularDbFields } = getEntityFieldContext(schema)
  const inputFields = regularDbFields.filter((field) =>
    isActionField(field, ENTITY_ACTION_FIELD_EXCLUSIONS)
  )
  const input = createInputObject(inputFields)
  const data = createEntityDataObject(schema)
  const events: DevModeLifecycleHookEvent[] = [
    'beforeCreate',
    'afterCreate',
    'beforeUpdate',
    'afterUpdate',
    'beforeDelete',
    'afterDelete',
    'beforeRestore',
    'afterRestore',
    'beforeReorder',
    'afterReorder'
  ]

  if (schema.actions?.draft === true) {
    events.push('beforePublish', 'afterPublish', 'beforeUnpublish', 'afterUnpublish')
  }

  return events.map((event) => ({
    id: lifecycleHookId(event),
    label: event,
    event,
    phase: lifecycleHookPhase(event),
    icon: lifecycleHookIcon(event),
    language: 'ts',
    code: lifecycleHookCode(schema.name, event, entityLabel, adminImportAlias),
    contextExample: lifecycleHookContextExample(event, schema.name, input, data)
  }))
}
